import { Component,OnInit } from '@angular/core';
import { BaseComponent, Constant } from 'app/infrastructure/common/index';

import { ReportFormatService } from 'app/infrastructure/services/base/index';
import { OnlineOrderService } from 'app/infrastructure/services/transaction/op/outbound/order/index';
import { WarehouseAuthService } from 'app/infrastructure/services/master/wm/config';
import {ReportService} from 'app/infrastructure/common/report.service';

@Component({
    selector: 'inventory-balance-by-asn-report',
    templateUrl: './inventory-balance-by-asn-report.html',
    styles: [`
        .input-group{
            border-spacing: 0; border-collapse: separate;
        }
        .input-group-addon{
            padding: 0 12px !important;
        }
    `]

})
export class InventoryBalanceByAsnReportComponent extends BaseComponent implements OnInit {
    isLoading: boolean = false;
    isLoadingReportFormats: boolean = false;
    isLoadingAccounts: boolean = false;
    isLoadingWarehouses: boolean = false;
    searchParams: any = {};
    reportFormats: any[] = [];
    warehouses:any[] = [];
    accounts:any[] = [];

    constructor( private reportService:ReportService,
		private reportFormatService: ReportFormatService,
        private onlineOrderService :OnlineOrderService,
        private warehouseAuthService:WarehouseAuthService) {
        super();
    }
    ngOnInit(): void {
        this.searchParams.ReportFormat = Constant.defaultReportFormat;
        this.searchParams.SortBy = "code";
        this.searchParams.GroupBy = "asn";

        this.loadReportFormats();
        this.loadAccounts();
        this.loadWarehouses();
    }
    loadReportFormats(): void {
        let self = this;
        this.isLoadingReportFormats = true;

        this.reportFormatService.getReportFormats()
            .subscribe(
            data => {
                self.isLoadingReportFormats = false;

                let message = data;
                if (message && message.MessageType && message.MessageType.Value) {
                    if (message.MessageType.Value == Constant.MessageType.success) {
                        self.reportFormats = message.Result;
                    }
                    else {
                        self.showAlert(message.MessageType.Value, message.MessageNumber, message.Message, message.AdditionalInformation);
                    }
                }
                else {
                    self.showAlert(Constant.MessageType.error, Constant.MessageNumber.defaultError, Constant.Message.defaultError);
                }
            },
            error => {
                self.isLoadingReportFormats = false;
                self.showAlert(Constant.MessageType.error, Constant.MessageNumber.defaultError, Constant.Message.defaultError, error);
            }
            );
    }
    loadAccounts(): void {
        let self = this;
        this.isLoadingAccounts = true;

        var groupId = this.token.GroupId;
        this.onlineOrderService.getAuthOwnerCustomerReprecentatives(groupId)
            .subscribe(
            data => {
                self.isLoadingAccounts = false;

                let message = data;
                if (message && message.MessageType && message.MessageType.Value) {
                    if (message.MessageType.Value == Constant.MessageType.success) {
                        self.accounts = message.Result;
                        self.searchParams.OwnerCode = self.token.DefaultOwnerCode;
                    }
                    else {
                        self.showAlert(message.MessageType.Value, message.MessageNumber, message.Message, message.AdditionalInformation);
                    }
                }
                else {
                    self.showAlert(Constant.MessageType.error, Constant.MessageNumber.defaultError, Constant.Message.defaultError);
                }
            },
            error => {
                self.isLoadingAccounts = false;
                self.showAlert(Constant.MessageType.error, Constant.MessageNumber.defaultError, Constant.Message.defaultError, error);
            }
            );
    }
    loadWarehouses(): void {
        let self = this;
        this.isLoadingWarehouses = true;

        var groupId = this.token.GroupId;
        this.warehouseAuthService.getWarehouseAuthsWithName(groupId)
            .subscribe(
            data => {
                self.isLoadingWarehouses = false;

                let message = data;
                if (message && message.MessageType && message.MessageType.Value) {
                    if (message.MessageType.Value == Constant.MessageType.success) {
                        self.warehouses = message.Result;
                        self.searchParams.WarehouseCode = self.token.DefaultWarehouseCode;
                    }
                    else {
                        self.showAlert(message.MessageType.Value, message.MessageNumber, message.Message, message.AdditionalInformation);
                    }
                }
                else {
                    self.showAlert(Constant.MessageType.error, Constant.MessageNumber.defaultError, Constant.Message.defaultError);
                }
            },
            error => {
                self.isLoadingWarehouses = false;
                self.showAlert(Constant.MessageType.error, Constant.MessageNumber.defaultError, Constant.Message.defaultError, error);
            }
            );
    }

    preview() {
        this.isLoading = true;
        let self = this;
        this.reportService.requestReport(this.searchParams,"InventoryBalanceReport/GetInventoryBalanceByAsnReport").subscribe(
            data => {
                self.isLoading = false;
                var fileURL = URL.createObjectURL(data);
                window.open(fileURL);
            },
            error => {
                self.isLoading = false;
                self.showAlert(Constant.MessageType.error, Constant.MessageNumber.defaultError, Constant.Message.defaultError, error);
            }
        );
    }

    showAlert(title: string, messageNumber: string, message: string, additionalInfo: string = null) {
        alert(title + ': (' + messageNumber + ') ' + message + '--' + (additionalInfo ? ' -- ' + additionalInfo : ''));
    }
}


// WEBPACK FOOTER //
// ./src/app/views/pages/transaction/reports/inventory-balance-by-asn/inventory-balance-by-asn-report.component.ts